<div class="search-container">
  <i class="far fa-search"></i>
  <input type="text" class="search-bar" placeholder="How can we help?" [formControl]="searchControl">
  <ul class="search-result-container">
    <li class="search-result-item" *ngFor="let result of searchResults$ | async" (click)="navigateToCategory(result)">
      <span class="title">{{result.subTitle}}</span>
      <span class="location">{{result.url}}<span *ngIf="result.subUrl">/{{result.subUrl}}</span></span>
    </li>
  </ul>
</div>
